import * as React from "react";
import { useLoaderData, useNavigate} from 'react-router-dom';
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import AddIcon from "@mui/icons-material/Add";
import Header from "../components/Header";
import Form from "../components/form/Form";
import FormButton from "../components/form/FormButton";
import FormDatePicker from "../components/form/FormDatePicker";
import FormMultiSelectChips from "../components/form/FormMultiSelectChips";
import FormNumberTextField from "../components/form/FormNumberTextField";
import { FormProvider } from "../components/form/FormProvider";
import { listElephants } from "../models/elephants";
import { listAssessments } from "../models/assessments";
import { startNewAssessment } from "../models/assessmentOperations";
import { getFacility } from "../models/facility";
import { useAuth } from "../context/AuthProvider";
import {useMessage} from '../context/MessageProvider';
import dayjs from "dayjs";

import { useConnectivity } from "../context/ConnectivityProvider";

import { isInProgress } from '../utils/assessments';


export async function loader() {
  const elephants = await listElephants();
  const assessments = await listAssessments();
  const facility = await getFacility();
  return { elephants, assessments, facility };
}

export default function AssessmentsFormPage({ title = "Assessments", ...props }) {
  const {setSuccess, setError} = useMessage();
  const { elephants, assessments, facility } = useLoaderData();

  //const [selected, setSelected] = useState([]);
  const {facilityId,user} = useAuth();
  const navigate = useNavigate();
  const {isOnline} = useConnectivity();

  const [working,setWorking] = React.useState(false);


  const handleSubmit = async (data) => {
    try{
      setWorking(true);
      console.log("handleSubmit data: ", data);

      const savePromises = (data.elephant_ids || []).map(elephantId => {
        return startNewAssessment({
          started_on: data.date,
          elephant_id: elephantId,
          facility_id: facilityId,
          user_id: user.id,
          is_online: isOnline,
          override_section_a_observations_total: data.override_section_a_observations_total,
          override_section_b_observations_total: data.override_section_b_observations_total,
        });
      });
      const promiseSaveResults = await Promise.all(savePromises);
      console.log("assessment saveResults: ", promiseSaveResults); 
      setSuccess("Assessments Started");
      navigate("/assessments");
    }
    catch(e){
      console.error(e)
      setError(e);
    } finally {
      setWorking(false);
    }
  };


  const inProgressAssessments = assessments.filter((cur)=>{
    return isInProgress(cur);
  });
  const elephantIdsThatAreInProgress = inProgressAssessments.map((cur)=>cur.elephant_id);

  const elephantsNotBeingAssessed = elephants.filter((elephant)=>{
    return elephantIdsThatAreInProgress.includes(elephant.id) === false;
  })

  const elephantList = elephantsNotBeingAssessed.map((cur)=>{
    return {
      value: cur.id,
      label: cur.name,
    };
  });

  return (
    <Container component="main" maxWidth="md">
      <Header label={title} />
      <FormProvider onSubmit={handleSubmit} defaultValues={{date:dayjs(), elephant_ids: [], override_section_a_observations_total: facility.section_a_observations_total, override_section_b_observations_total: facility.section_b_observations_total}}>
        <Form>
          <Grid rowSpacing={4} container spacing={2} alignItems="center">
            <Grid item xs={12} s={3}>
              <FormDatePicker onChange={(e) => console.log(e)} name="date" label="Start Date" required />
            </Grid>
            <Grid item xs={12} s={3}>
              <FormMultiSelectChips name="elephant_ids" label="Elephants To Assess" required list={elephantList} enableSelectAll={true} />
            </Grid>

            <Grid xs={12} sm={6}> 
              <FormNumberTextField name="override_section_a_observations_total" label="Section A Observations Total" required min={4} max={12} />
            </Grid>

            <Grid xs={12} sm={6}> 
              <FormNumberTextField name="override_section_b_observations_total" label="Section B Observations Total" required min={12} max={36}/>
            </Grid>


            <Grid container xs={12} marginBottom={2} justifyContent="flex-end">
              <Grid>
                <FormButton working={working}>
                  <AddIcon />
                  Add Assessment(s)
                </FormButton>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      </FormProvider>
    </Container>
  );
}
